<template>
    <div class="login-warpper">
        <div class="logo">
            <img alt="" src="../../assets/img/h5-logo.png"/>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="rules" class="login-container margin-top ">
            <div class="login-title flex align-center justify-around">
                <span class="active">登录</span>
            </div>
            <el-form-item prop="account">
                <el-input
                    v-model="loginForm.account"
                    placeholder="请输入帐号/企业全称">
                    <i slot="prefix" class="iconfont icon-yonghu "></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input
                    v-model="loginForm.password"
                    placeholder="请设置密码"
                    type="password">
                    <i slot="prefix" class="iconfont  icon-mima"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="code">
                <el-input
                    v-model="loginForm.code"
                    class="verify"
                    placeholder="请输入验证码">
                    <i slot="prefix" class="iconfont icon-verify"></i>
                    <span slot="append" class="color-style" @click="setCode">{{ codeInfo }}</span>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="login-btn" @click="submitForm('loginForm')">立即登录</el-button>
            </el-form-item>
            <router-link class="flex justify-end" to="/mobile/register">
                <div class="login">我要注册</div>
            </router-link>
        </el-form>
        <div class="footer flex flex-direction align-center justify-around">
            版权所有©2017-2022 北京消防协会
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040396" target="_blank">京公网安备11010502040396号</a>
            <a href="http://beian.miit.gov.cn" target="_blank">京ICP备15022697号-1</a>
            <!--            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214" target="_blank">京公网安备11010802038214号</a>-->
            <!--            <a href="http://beian.miit.gov.cn" target="_blank">京ICP备15038897号-3</a>-->
        </div>
    </div>
</template>

<script>
import {login} from "@/api/login";

export default {
    name: "notice",
    data() {
        var checkCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入验证码'));
            } else if (value.toLowerCase() !== this.codeInfo.toLowerCase()) {
                callback(new Error('验证码输入有误'));
            } else {
                callback();
            }
        };
        return {
            codeInfo: '',
            loginForm: {
                account: '',
                password: '',
                code: ''
            },
            rules: {
                account: [{required: true, message: '请输入帐号/企业全称', trigger: 'blur'}],
                password: [{required: true, message: '请输入密码', trigger: 'blur'},
                    {min: 6, message: '密码长度需6位及以上', trigger: 'blur'}],
                code: [{validator: checkCode, trigger: 'blur'}],
            },
        }
    },

    components: {},
    created() {
        this.$store.state.token = ''
        this.$store.state.user = ''
        window.localStorage.clear()
        this.setCode()
    },
    mounted() {

    },
    methods: {
        //    登录提交
        async toLogin() {
            const loading = this.$loading({
                lock: true,
                text: '登录中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let _data = await login(this.loginForm.account, this.loginForm.password)
            loading.close();
            this.$store.state.token = _data.data.token
            this.$store.state.user = _data.data
            setTimeout(() => {
                if (_data.data.user_type === 1) {         //  会员
                    this.$router.replace('/mobile/info')
                } else {
                    this.$router.replace('/mobile/admin/member/list')
                }
            }, 500)

        },
        //验证登录信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.toLogin()
                }
            });
        },
        //  设置随机验证码
        setCode() {
            var code = "";
            let code_l = 4 //验证码长度
            let codeChars = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
            ]
            for (let i = 0; i < code_l; i++) {
                var charNum = Math.floor(Math.random() * 52);
                code += codeChars[charNum];
            }
            this.codeInfo = code
        },
    }
}
</script>

<style lang="scss" scoped>
.login-warpper {
    height: 100vh;
    overflow-y: scroll;
    padding-bottom: 60px;
    background: url(../../assets/img/h5-bg.png) no-repeat top center;

    .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        img {
            display: block;
            width: 80%;
        }
    }
}

.login-title {
    padding: 20px 40px 10px;

    span {
        display: block;
        font-size: 14px;
        line-height: 30px;
        cursor: pointer;

        &.active {
            color: #0d7fd7;
            border-bottom: 1px solid #0d7fd7;
        }
    }

    i {
        display: block;
        width: 1px;
        height: 18px;
        background: #ccc;
    }

}

.login-container {
    margin: 20px;
    background: #FFFFFF;
    border-radius: 5px;
    padding: 0 30px 20px;
}

.form-item {
    position: relative;
}

.form-item .forget {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2px;
    display: block;
    height: 30px;
    width: 101px;
    line-height: 30px;
    color: #0d7fd7;
    text-align: center;
    background: #fff;
    cursor: pointer;
}

.color-style {
    display: block;
    width: 60px;
    text-align: center;
    color: #0d7fd7;
    font-size: 14px;
    letter-spacing: 3px;
    cursor: pointer;
}

.login {
    font-size: 14px;
    color: #0d7fd7;

    span {
        color: #0d7fd7;
    }
}


.login-btn {
    display: block;
    width: 100%;
    height: 40px;
    background-color: #f60000;
    border-radius: 4px;
    border: 0;
    font-size: 16px;
    color: #fff;
    cursor: pointer;
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 70px;
    padding: 10px 0;
    background: #333;
    color: #fff;
    font-size: 10px;
    text-align: center;

    a {
        font-size: 10px;
        color: #fff;
    }
}
</style>